import React from 'react';
import { CtaButton } from './CtaButton';
export function Footer() {
  return <footer className="w-full bg-cream-deep px-5 pb-32 pt-14 sm:px-8" data-id="element-134" data-mp="3gf96f0gd6eb2">
      <div className="mx-auto max-w-2xl text-center" data-id="element-135" data-mp="3ghc323c0v5or">
        <p className="font-display text-xl font-bold tracking-tight text-ink" data-id="element-136" data-mp="32onll67cnuaj">
          Resin Architect™
        </p>
        <p className="mt-1 text-[13px] font-semibold uppercase tracking-[0.16em] text-gold-deep" data-id="element-137" data-mp="36q94b86kf2sn">
          Dr. Karito
        </p>

        <CtaButton className="mx-auto mt-8 max-w-sm" label="Get it for $27" variant="ink" data-id="element-138" data-mp="3ud7ghtnnjokr" />

        <div className="my-8 hairline" data-id="element-139" data-mp="36msyjwt2ysh" />

        <p className="text-[12px] leading-relaxed text-clay" data-id="element-140" data-mp="3levi35gjnmhr">
          © 2026 · Dr. Karito – Resin Architect™. All rights reserved.
        </p>
        <p className="mt-3 text-[11px] leading-relaxed text-clay/80" data-id="element-141" data-mp="3qblwzpgm4c1l">
          Resin Architect™ is an educational and reference resource. It does not replace
          professional education, clinical judgment, patient-specific assessment, applicable
          regulations or manufacturer instructions.
        </p>
      </div>
    </footer>;
}